export default __webpack_public_path__ + "assets/Regions-f3850f9fb49a7b30a92ff743af328782.svg";